// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"029377d2","193":"24a51959","216":"5d46bf8c","274":"40087f01","293":"a0db5ed8","329":"eb0c3150","475":"dcf7bb1a","669":"474b7d8b","677":"2c399844","773":"6a3c68c3","925":"4f2fe926","986":"1f1218d5"}[chunkId] + ".chunk.js";
};